module.exports = __webpack_public_path__ + "f20bd08ba0c296284df66901d03e6e4f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/duke_university_2021_chart.png
// module id = 1668
// module chunks = 0